import { render, staticRenderFns } from "./StatsFinancial.vue?vue&type=template&id=ebf4f0a2&scoped=true"
import script from "./StatsFinancial.vue?vue&type=script&lang=js"
export * from "./StatsFinancial.vue?vue&type=script&lang=js"
import style0 from "./StatsFinancial.vue?vue&type=style&index=0&id=ebf4f0a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebf4f0a2",
  null
  
)

export default component.exports